import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./components/pages/routes";
import MobileNavbar from "./components/layout/MobileNavbar";
import Footer from "./components/layout/Footer";
import LocaleProvider from "./locales/LocaleProvider";
import "./App.css";

import "./locales/i18n";

const App = () => {
  return (
    <LocaleProvider>
      <Router>
        <MobileNavbar />
        <Routes />
        <Footer />
      </Router>
    </LocaleProvider>
  );
};

export default App;
